import React from 'react';
import type { SocialNetwork } from '@agency-smm/shared';

const s = (d: string, color: string, vb = '0 0 24 24') => (
  <svg width="14" height="14" viewBox={vb} fill={color} style={{ display: 'inline-block', verticalAlign: 'middle' }}>
    <path d={d} />
  </svg>
);

// Instagram
const instagram = s(
  'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z',
  '#E4405F'
);

// Facebook
const facebook = s(
  'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
  '#1877F2'
);

// Twitter/X
const twitter = s(
  'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
  '#000000'
);

// LinkedIn
const linkedin = s(
  'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  '#0A66C2'
);

// TikTok
const tiktok = s(
  'M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z',
  '#000000'
);

// Threads
const threads = s(
  'M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.17.408-2.265 1.333-3.082.862-.762 2.07-1.239 3.494-1.381 1.016-.1 2.025-.058 2.997.123-.068-1.127-.397-1.955-.977-2.46-.63-.55-1.588-.828-2.845-.828h-.038c-.96.008-1.777.264-2.428.762l-1.206-1.606c.989-.744 2.213-1.14 3.64-1.175h.056c1.81 0 3.227.532 4.213 1.582.912.973 1.388 2.347 1.413 4.08v.107c0 .024 0 .048-.002.073a8.876 8.876 0 01-.019.325c1.073.63 1.927 1.49 2.475 2.543.792 1.524 1.013 3.906-.658 5.623C18.3 22.956 15.945 23.97 12.186 24zm-1.638-8.073c-.32.018-.622.063-.905.134 1.08-.088 1.962.132 2.521.636.39.352.628.87.712 1.54.19-.12.352-.258.483-.412.456-.536.703-1.29.735-2.241-.645-.11-1.312-.159-1.983-.151-.565.008-1.132.06-1.563.494z',
  '#000000'
);

// Bluesky
const bluesky = s(
  'M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.785 2.627 3.624 3.593 6.224 3.232-4.607.703-6.004 3.034-3.374 5.345 3.024 2.657 5.189-.39 6.526-2.864.311-.576.468-.856.526-.856.057 0 .214.28.526.856 1.337 2.474 3.502 5.521 6.526 2.864 2.63-2.311 1.233-4.642-3.374-5.345 2.6.361 5.439-.605 6.224-3.232C20.622 9.418 21 4.458 21 3.768c0-.688-.139-1.86-.902-2.203-.659-.299-1.664-.621-4.3 1.24C13.046 4.747 10.087 8.686 9 10.8h3z',
  '#0085FF',
  '0 0 21 18'
);

// Google Business Profile
const gbp = s(
  'M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z',
  '#4285F4'
);

export const NETWORK_ICONS: Record<string, React.ReactNode> = {
  instagram,
  facebook,
  twitter,
  linkedin,
  tiktok,
  threads,
  bluesky,
  gbp,
};

export const PLATFORM_LIST: { id: SocialNetwork; label: string; icon: React.ReactNode }[] = [
  { id: 'instagram', label: 'Instagram', icon: instagram },
  { id: 'facebook', label: 'Facebook', icon: facebook },
  { id: 'linkedin', label: 'LinkedIn', icon: linkedin },
  { id: 'twitter', label: 'Twitter/X', icon: twitter },
  { id: 'tiktok', label: 'TikTok', icon: tiktok },
  { id: 'threads', label: 'Threads', icon: threads },
  { id: 'bluesky', label: 'Bluesky', icon: bluesky },
  { id: 'gbp', label: 'Google Biz', icon: gbp },
];
